function y(f) {
  f.setAttribute("autocomplete", "off");
}
function k(f, { onClick: d, onFocus: r, onInput: v, onKeyDown: u, onSubmit: l }, { form: c = f.form ?? void 0, nativeSubmit: p } = {}) {
  const o = [];
  function i(e, s, a) {
    e.addEventListener(s, a), o.push(() => e.removeEventListener(s, a));
  }
  return (u || l) && i(f, "keydown", (e) => {
    const s = u?.(f.value, e.key);
    u && (e.key === "ArrowDown" || e.key === "ArrowUp") ? e.preventDefault() : l && e.key === "Enter" && (f.value !== "" && !e.repeat && !s && l(f.value), p || e.preventDefault());
  }), l && c && (i(c, "submit", (e) => {
    p || e.preventDefault(), l(f.value);
  }), c.querySelectorAll("[type=submit]").forEach((e) => {
    i(e, "click", (s) => {
      p || s.preventDefault(), l(f.value);
    });
  })), d && i(f, "click", () => d(f.value)), r && i(f, "focus", () => r(f.value)), v && i(f, "input", () => v(f.value)), {
    destroy() {
      o.forEach((e) => e());
    }
  };
}
export {
  k as b,
  y as d
};
